module.exports = __webpack_public_path__ + "img/moon.7b10c7ae.png";